import React from 'react'

export interface ITextCell {
  content: any
}

export const TextArrayCell: React.FC<ITextCell> = props => (Array.isArray(props.content) ? <>{props.content.join(', ')}</> : null)

export default React.memo(TextArrayCell as React.FC<ITextCell>)
